import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { compose } from "redux";
import QRCode from "qrcode.react";
import cx from "classnames";
import _ from "lodash";

import Circle from "assets/images/CT/circle.png";
import backIconTw from "assets/images/tw/back-icon.png";
import backArrow from "assets/images/bingo/back-arrow.png";
import LeftArrrow from "assets/images/verboden/leftArrow.png";
import BackLeftArrow from "assets/images/verboden/backLeftArrow.png";
import {
  slideHorizontalLeftVariants,
  slideHorizontalLeftExitVariants
} from "components/shared/utils/animations";
import Alert from "components/shared/common/alert";
import * as socketAction from "redux/sockets/action";
import { withSocket } from "socket/context";
class Scanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      color: ""
    };
  }

  joinRoom = () => {
    const branchLinkSplit = this.props.link.split("/")[3];
    let copyToClip = `http://link.heylime.com/${branchLinkSplit}`;
    var textArea = document.createElement("textarea");
    document.body.append(textArea);
    document.body.lastElementChild.value = copyToClip;
    document.body.lastElementChild.select();
    document.execCommand("copy");
    textArea.remove();
    Alert(200, "Link copied successfully");
  };
  onBack = () => {
    this.props.history.push("/");
  };
  hexToRGB = (hex, alpha) => {
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha !== "") {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  };
  render() {
    const {
      className = "",
      joinCodeTextClassName = "",
      type = "",
      isBackButton = false,
      dw20 = false,
      OCH = false,
      GAH = false,
      CHPT = false,
      CT = false,
      slideKick = false,
      fluster = false,
      BNG = false,
      SBS = false,
      TW = false,
      gameName = "",
      sub_game_code = "",
      vb_start_game = null
    } = this.props;

    let joinCode = "Loading";
    const roomData = this.props.gameReducer.roomObj;
    const link = this.props.link;

    if (roomData && roomData.join_code) {
      joinCode = roomData.join_code;
    }
    let joinCodeText = "Enter This Join Code in App:";
    let scanText = "Scan This Code";
    let joinNowText = "JOIN NOW!";
    let backBtnText = "BACK";

    if (this.props.paramsReducer && this.props.paramsReducer.gameObj) {
      let gameObj = this.props.paramsReducer.gameObj;
      if (gameObj && gameObj.screens && gameObj.screens.lobby) {
        joinCodeText = gameObj.screens.lobby.join_instructions_bottom;
        scanText = gameObj.screens.lobby.join_instructions_top;
        joinNowText = gameObj.screens.lobby.join_header;
        backBtnText = gameObj.screens.lobby.back_button_text;
      }
    }
    if (type === "DW20" || dw20) {
      backBtnText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.back_button_text"
      );
      joinNowText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.join_header"
      );
      scanText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.join_instruction_top"
      );
      joinCodeText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.join_instructions_bottom"
      );
    }
    if (type === "tot") {
      backBtnText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.back_button_text"
      );
      joinNowText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.join_header"
      );
      scanText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.join_instructions_top"
      );
      joinCodeText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.lobby.join_instructions_bottom"
      );
    }
    if (CHPT) {
      backBtnText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.chpt.back_button"
      );
      joinNowText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.chpt.join_code"
      );
      scanText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.chpt.join_instructions_top"
      );
      joinCodeText = _.get(
        this.props,
        "paramsReducer.gameObj.screens.chpt.join_instructions_bottom"
      );
    }
    if (CT) {
      backBtnText = _.get(
        this.props,
        "paramsReducer.gameObj.1_lobby.back_button"
      );
      scanText = _.get(
        this.props,
        "paramsReducer.gameObj.1_lobby.scan_to_join"
      );
      joinCodeText = _.get(
        this.props,
        "paramsReducer.gameObj.1_lobby.join_code"
      );
    }

    if (slideKick) {
      let joining_data = this.props?.paramsReducer?.gameObj.joining;
      joinCodeText = joining_data?.join_code_bottom
        ? joining_data.join_code_bottom
        : "Enter join code below";
      scanText = joining_data?.scan_bottom
        ? joining_data?.scan_bottom
        : "Scan here";
      joinNowText = joining_data?.scan_top
        ? joining_data?.scan_top
        : "Scan the Code";
    }
    if (fluster) {
      const joining_params = _.get(
        this.props,
        "paramsReducer.gameObj.screens.1_joining"
      );
      backBtnText = _.get(joining_params, "back");
      joinNowText = _.get(joining_params, "join_now");
      scanText = _.get(joining_params, "scan_this_code");
      joinCodeText = _.get(joining_params, "enter_this_code");
    }
    if (BNG) {
      backBtnText = "Back";
      joinNowText = "JOIN NOW!";
      scanText = "Scan this code";
      joinCodeText = "Enter this join code in the app";
    }

    let backgroundColor =
      this.props?.paramsReducer?.gameObj?.tabletop_placemat_rgb;
    let backgroundTrans =
      this.props?.paramsReducer?.gameObj?.tabletop_placemat_transparency;
    let colors = "";
    if (backgroundColor) {
      colors = this.hexToRGB(backgroundColor, backgroundTrans);
    }

    return (
      <motion.div
        variants={
          sub_game_code === "TTL" || vb_start_game === false
            ? slideHorizontalLeftVariants
            : vb_start_game
            ? slideHorizontalLeftExitVariants
            : {}
        }
        initial="hidden"
        animate="visible"
        exit="exit"
        className={`h-100 sbs-tot-col-3-height bingo-col3-height ${
          type === "GAH" ? "GAH-lobby-border" : ""
        }`}
      >
        {CT && (
          <div className="text-center CT-card">
            <Button onClick={() => this.props.onBack()} className="back-btn">
              {backBtnText}
            </Button>
          </div>
        )}
        {this.props.gameName === "TW" && (
          <div className="text-center CT-card">
            <Button onClick={() => this.props.onBack()} className="back-btn">
              back
            </Button>
          </div>
        )}

        <div
          className={cx(
            " l-8  h-100 text-center justify-content-between joinNow ttl-lobby-card",
            className,
            {
              "bg-g-theme lobby-card d-flex flex-column":
                type !== "verboden" &&
                type !== "tot" &&
                type !== "GAH" &&
                type !== "CHPT" &&
                type !== "BNG" &&
                !dw20 &&
                !OCH,
              "px-5": type === "tot"
            }
          )}
          style={
            dw20
              ? { background: colors }
              : fluster
              ? { background: "black" }
              : {}
          }
        >
          {BNG && (
            <div className="bingo_Back_btn">
              <Button onClick={() => this.props.onBack()}>
                {" "}
                <img src={backArrow} alt="" /> {backBtnText}
              </Button>
            </div>
          )}
          {isBackButton && (
            <div className="text-center">
              <div>
                <Button
                  onClick={() => this.props.onBack()}
                  color="themeBlue text-uppercase back-btn"
                >
                  {type === "verboden" ? (
                    <img src={BackLeftArrow} alt="" className="mr-4" />
                  ) : (
                    <img src={LeftArrrow} alt="" className="mr-4" />
                  )}
                  {backBtnText}
                </Button>
              </div>
            </div>
          )}
          <div
            className={cx({
              "flex-grow-1 d-flex flex-column ct-content":
                type !== "verboden" &&
                type !== "tot" &&
                type !== "BNG" &&
                !dw20 &&
                !OCH &&
                !CHPT &&
                CT
            })}
          >
            {type === "TW" && (
              <Button
                onClick={() => this.props.onBack()}
                className="back-btn-tw"
              >
                <img src={backIconTw} alt="" />
                {backBtnText}
              </Button>
            )}
            {!CT && !slideKick && (
              <h1 className="text text-uppercase title">{joinNowText}</h1>
            )}
            {CHPT && (
              <p className="text">
                <b>{scanText}</b>
              </p>
            )}

            {CT && <p className="text">{scanText}</p>}
            {SBS && <p className="text-sbs">Scan the QR code</p>}

            {BNG && <p className="scan_text">scan this code</p>}
            {slideKick && <p className="scan_text_slidekick">Scan the Code</p>}

            {GAH && (
              <p className="text">
                <b>{scanText}</b>
              </p>
            )}
            {type === "TW" && <p className="scan_text">scan this code</p>}
            <div
              className={cx("qrWrapper", {
                "flex-grow-1 d-flex align-items-center":
                  type !== "verboden" && type !== "tot" && !OCH && !dw20 && CT
              })}
            >
              {link !== undefined ? (
                <QRCode
                  value={link && link !== "" ? link : "Loading"}
                  size={400}
                  bgColor="transparent"
                  fgColor={
                    GAH
                      ? "#252F4C"
                      : dw20 || slideKick
                      ? "#2A2A2A"
                      : OCH
                      ? "#000000"
                      : CHPT
                      ? "rgb(255,255,255,0.8)"
                      : CT
                      ? "#231F1F"
                      : "#fff"
                  }
                />
              ) : (
                <div class="loader-back">
                  <div class="loader"></div>
                </div>
              )}
            </div>
            {!CT && (
              <h4 className="text scan-text">
                {type === "tot" ||
                type === "OCH" ||
                type === "slideKick" ||
                type === "fluster" ||
                type === "DW20" ||
                type === "verboden"
                  ? scanText
                  : null}
              </h4>
            )}
          </div>
          <div
            className="ct-circlebg"
            style={
              CT
                ? {
                    backgroundImage: `url(${Circle})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 58%",
                    backgroundPosition: "bottom"
                  }
                : {}
            }
          >
            <p className="text textLine or-text">OR</p>
            <p className={cx("text", joinCodeTextClassName)}>
              {SBS ? <b>Enter this code in the app:</b> : <b>{joinCodeText}</b>}
            </p>

            <Button
              onClick={() => this.joinRoom()}
              className={type === "verboden" ? "qr-code text" : "w-100 joinBtn"}
            >
              {link && link !== "" ? joinCode : "Loading"}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path
                  className="copy-icon"
                  fill={
                    SBS === true
                      ? "white"
                      : fluster === true
                      ? "#e8a423"
                      : BNG === true
                      ? "#205fc7"
                      : "black"
                  }
                  d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                />
              </svg>
            </Button>

            {CT && <p className="ct-text">what does it mean???</p>}
            {SBS && (
              <div>
                <p className="text textLine or-text or-text2">OR</p>
                <p className="goto">Go to this url:</p>
                <p className="url"> {this.props.mobileUrl}</p>
              </div>
            )}
          </div>
        </div>
      </motion.div>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, null)
)(Scanner);
